var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-snackbars',{attrs:{"objects":_vm.objects,"color":"red","bottom":"","left":""},on:{"update:objects":function($event){_vm.objects=$event}},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var index = ref.index;
return [_c('v-icon',{key:index},[_vm._v("\n                "+_vm._s(_vm.iconoTipo[_vm.objects[index].color])+"\n            ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }